import { Injectable } from '@angular/core';

@Injectable()
export class ForSigningModelService {

  model: any;

  setData(data) {
    this.model = data;
  }

  getData() {
    return this.model;
  }

  removeData() {
    this.model = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/for-signing/for-signing.model.service.ts